export default {
  viewBox: "0 0 512 512",
  html: "<path d=\"M329 256c0 5-2 9-5 13L196 397c-4 3-8 5-13 5s-9-2-13-5c-4-4-5-8-5-13V128c0-5 1-9 5-13 4-3 8-5 13-5s9 2 13 5l128 128c3 4 5 8 5 13\"/>"
};